const splitFilename = (filename) => {
  if (typeof filename !== 'string' || filename.length === 0) {
    return {
      baseName: '',
      extension: '',
    };
  }

  const lastDotIndex = filename.lastIndexOf('.');

  if (lastDotIndex <= 0 || lastDotIndex === filename.length - 1) {
    return {
      baseName: filename,
      extension: '',
    };
  }

  return {
    baseName: filename.slice(0, lastDotIndex),
    extension: filename.slice(lastDotIndex),
  };
};

const getFilenameBase = (filename) => splitFilename(filename).baseName;

const getFilenameExtension = (filename) => splitFilename(filename).extension;

const composeFilename = (baseName, extension = '') => `${baseName}${extension}`;

const preserveFilenameExtension = (filename, extension = '') => {
  if (!extension || typeof filename !== 'string') {
    return filename;
  }

  if (filename.endsWith(extension)) {
    return filename;
  }

  return composeFilename(filename, extension);
};

export default {
  splitFilename,
  getFilenameBase,
  getFilenameExtension,
  composeFilename,
  preserveFilenameExtension,
};
